import { useQuery as a, useQueryClient as o, useMutation as i } from "@tanstack/react-query";
import t from "./course-plan.api.js";
import { teachurKeys as r } from "../../constants/teachurKeys.js";
const q = (e) => a({
  queryKey: r.coursePlan.saved(),
  queryFn: async () => (await t.get()).data,
  retry: !1,
  ...e
}), d = (e, s) => {
  const { enabled: n = !1, ...u } = s ?? {};
  return a({
    queryKey: r.coursePlan.suggestion(e),
    queryFn: async () => (await t.getSuggestion(e)).data,
    retry: !1,
    enabled: n && e != null,
    ...u
  });
}, g = (e, s) => a({
  queryKey: r.coursePlan.options(e),
  queryFn: async () => (await t.getOptions(e)).data,
  retry: !1,
  ...s
}), v = (e) => {
  const s = o();
  return i({
    mutationFn: async (n) => (await t.save(n)).data,
    onSuccess: async (n) => {
      s.setQueryData(r.coursePlan.saved(), n), await s.invalidateQueries({ queryKey: r.users.currentUser() }), s.invalidateQueries({ queryKey: r.degrees.all }), s.invalidateQueries({ queryKey: r.courses.all });
    },
    meta: {
      successMessage: "Course plan saved",
      errorMessage: "Failed to save course plan"
    },
    ...e
  });
};
export {
  g as useGetCourseOptionsQuery,
  q as useGetCoursePlanQuery,
  d as useGetCoursePlanSuggestionQuery,
  v as useSavePlanMutation
};
